import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AuthFooter = () => {
  const { t } = useTranslation();
  return (
    <div>
      {/* <!-- Footer Section --> */}
      <footer className="auth-footer py-1">
        <div className="container d-flex align-items-center  justify-content-between">
          {/* <!-- Copyright Line and Terms on one line --> */}
          <div className="footer-bottom  align-items-center">
            <span className="copyright-text">
              {t(
                "©Copyright {{year}} Offary. All rights reserved."
              ).replace("{{year}}", moment().format("YYYY"))}{" "}
            </span>
            <span className="terms-text">
              <Link to="/t&c">{t("Terms & Conditions")}</Link> |{" "}
              <Link to="/privacy-policy">{t("Privacy Policy")}</Link>
            </span>
          </div>
          {/* <!-- Social Media Icons --> */}
          <div className="social-icons-footer justify-content-center mb-3">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              className="social-icon"
            >
              <i className="fa fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/accounts/login/?hl=en"
              target="_blank"
              className="social-icon"
            >
              <i className="fa fa-instagram"></i>
            </a>
            <a href="https://x.com/" target="_blank" className="social-icon">
              <i className="fa fa-twitter"></i>
            </a>
            <a
              href="https://www.youtube.com/"
              target="_blank"
              className="social-icon"
            >
              <i className="fa fa-youtube"></i>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthFooter;
